import { render, staticRenderFns } from "./ClubBlog.vue?vue&type=template&id=4864cc96&"
import script from "./ClubBlog.vue?vue&type=script&lang=js&"
export * from "./ClubBlog.vue?vue&type=script&lang=js&"
import style0 from "./ClubBlog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports